<template>
    <v-card>
        <v-card-title>
            <span class="text-h5">Success</span>
        </v-card-title>
        <v-card-text>
            <v-container class="d-flex flex-column justify-content-center">
                <div class="svg-container text-center" v-if="success">
                    <svg class="ft-green-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100"
                         viewBox="0 0 48 48"
                         aria-hidden="true">
                        <circle class="circle" fill="#5bb543" cx="24" cy="24" r="22"/>
                        <path class="tick" fill="none" stroke="#FFF" stroke-width="6" stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10" d="M14 27l5.917 4.917L34 17"/>
                    </svg>
                </div>
                <div class="mt-4 text-center">
                    {{ message }}
                </div>
                <div class="m-4 text-center">
                    <v-btn
                        v-if="frontend_view_folder == 'frontend.mountain_haus'"
                        color="primary"
                        @click="printReservation()"
                    >
                        Print
                    </v-btn>
                </div>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name : "MessageModal",
    props: {
        'message': null,
        'success': {default: true}
    },

    methods: {
        printReservation(){
            if(this.auto_printing_is_enabled && !window.location.href.includes('seasonal')){
                if(this.is_seasonal){
                    window.location.href = '/reservations/seasonal_kiosk/print_form';
                }else{
                    window.location.href = '/reservations/kiosk/print_form';
                }
            }
        }
    },
    computed: {
        auto_printing_is_enabled() {
            return parseInt(this.$store.state.resources.config.auto_printing_is_enabled);
        },
        frontend_view_folder() {
            return this.$store.state.resources.config.frontend_view_folder;
        },
    }
}
</script>

<style scoped>
.success-icon {
    background-color: white;
    padding: 50px !important;
    padding-top: 30px !important;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;
}

@supports (animation: grow .5s cubic-bezier(.25, .25, .25, 1) forwards) {
    .tick {
        stroke-opacity: 0;
        stroke-dasharray: 29px;
        stroke-dashoffset: 29px;
        animation: draw .5s cubic-bezier(.25, .25, .25, 1) forwards;
        animation-delay: .6s
    }

    .circle {
        fill-opacity: 0;
        stroke: #0098df;
        stroke-width: 16px;
        transform-origin: center;
        transform: scale(0);
        animation: grow 1s cubic-bezier(.25, .25, .25, 1.25) forwards;
    }
}

@keyframes grow {
    60% {
        transform: scale(.8);
        stroke-width: 4px;
        fill-opacity: 0;
    }
    100% {
        transform: scale(.9);
        stroke-width: 8px;
        fill-opacity: 1;
        fill: #0098df;
    }
}

@keyframes draw {
    0%, 100% {
        stroke-opacity: 1;
    }
    100% {
        stroke-dashoffset: 0;
    }
}


@-webkit-keyframes swal2-animate-error-x-mark {
    0% {
        margin-top: 1.625em;
        -webkit-transform: scale(.4);
        transform: scale(.4);
        opacity: 0
    }
    50% {
        margin-top: 1.625em;
        -webkit-transform: scale(.4);
        transform: scale(.4);
        opacity: 0
    }
    80% {
        margin-top: -.375em;
        -webkit-transform: scale(1.15);
        transform: scale(1.15)
    }
    100% {
        margin-top: 0;
        -webkit-transform: scale(1);
        transform: scale(1);
        opacity: 1
    }
}

@keyframes swal2-animate-error-icon {
    0% {
        -webkit-transform: rotateX(100deg);
        transform: rotateX(100deg);
        opacity: 0
    }
    100% {
        -webkit-transform: rotateX(0);
        transform: rotateX(0);
        opacity: 1
    }
}

.swal2-icon {
    position: relative;
    justify-content: center;
    width: 5em;
    height: 5em;
    margin: 1.25em auto 1.875em;
    border: .25em solid transparent;
    border-radius: 50%;
    line-height: 5em;
    cursor: default;
    box-sizing: content-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    zoom: normal
}

.swal2-icon.swal2-error {
    border-color: #f27474
}

.swal2-icon.swal2-error .swal2-x-mark {
    position: relative;
    flex-grow: 1
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
    display: block;
    position: absolute;
    top: 2.3125em;
    width: 2.9375em;
    height: .3125em;
    border-radius: .125em;
    background-color: #f27474
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left] {
    left: 1.0625em;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg)
}

.swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right] {
    right: 1em;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg)
}

.swal2-animate-error-icon {
    -webkit-animation: swal2-animate-error-icon .5s;
    animation: swal2-animate-error-icon .5s
}

.swal2-animate-error-icon .swal2-x-mark {
    -webkit-animation: swal2-animate-error-x-mark .5s;
    animation: swal2-animate-error-x-mark .5s
}
</style>
